<template>
    <div>
        <b-modal id="modal-bulk-assign-update" no-close-on-esc centered no-close-on-backdrop hide-footer
            :body-class="'pt-3'">
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('bulkAssignUpdate.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-left">
                <label class="state">{{ $t('bulkAssignUpdate.assignedToLabel') }}</label>
                <v-select class="bg_white w-100 f-12" v-model="assigned_to" :options="nameOptions" item-value="id"
                    item-text="label" :reduce="(option) => option.id" @search="searchUsers">
                    <span slot="no-options">
                        {{ $t('bulkAssignUpdate.searchUser') }}
                    </span>
                </v-select>
                <p v-if="error && error.assigned_to" class="field-error">
                    {{ error.assigned_to[0] }}
                </p>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('bulkAssignUpdate.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" @click="bulkUpdateTasks">{{ $t('bulkAssignUpdate.save') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "BulkAssignUpdate",
    components: {
        vSelect,
    },
    data() {
        return {
            error: {},
            assigned_to: null,
            nameOptions:[]
        }
    },
    props: ["title", "taskIds"],
    computed:{
        ...mapGetters(["allTeamMembers"]),
    },
    methods: {
        ...mapActions(["updateBulkTasks", "setNotification", "setLoader", "getAllTeamMembers"]),
        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        resetPopup() {
            this.error = {}
            this.assigned_to = null
            this.nameOptions = []
            this.$bvModal.hide('modal-bulk-assign-update')
            this.$emit('close')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === null) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async bulkUpdateTasks() {
            try {
                const nullKeys = this.checkNullValues({
                    assigned_to: this.assigned_to
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.updateBulkTasks({
                        "task_ids": this.taskIds,
                        "assigned_to": this.assigned_to
                    })
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('bulkAssignUpdate.tasksUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("updateDocs")
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('bulkAssignUpdate.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.error = error;
                }
            }
        }
    },
}
</script>